import { render } from "./AutoScaleLoadBalancing.vue?vue&type=template&id=a56ab368&scoped=true"
import script from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"
export * from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"

import "./AutoScaleLoadBalancing.vue?vue&type=style&index=0&id=a56ab368&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56ab368"]])

export default __exports__